export type TextFormatter = 'ucFirst' | 'lcWord'

const formatterMap: Record<TextFormatter, (value: string) => string> = {
  ucFirst: (value) => value.charAt(0).toUpperCase() + value.slice(1),
  lcWord: (value) =>
    value.replace(
      /\w+/g,
      (word) => word.charAt(0) + word.slice(1).toLowerCase(),
    ),
}

export const presets: Record<string, Array<TextFormatter>> = {
  name: ['ucFirst', 'lcWord'],
}

export const format = (value: string, formatters: Array<TextFormatter>) =>
  formatters.reduce(
    (previous, current) => formatterMap[current](previous),
    value,
  )
